import { gqlRequest } from '@mdvip/shared/lib/graphql-client';
import { type UseMutationResult, useMutation } from '@tanstack/react-query';
import { CreateProfilePhotoUploadUrlDocument } from '@/graphql/generated/graphql';

export interface ProfilePhotoUploadUrl {
  url: string;
  expiresAt: string;
}

async function requestProfilePhotoUploadUrl(): Promise<ProfilePhotoUploadUrl> {
  const data = await gqlRequest(CreateProfilePhotoUploadUrlDocument);
  return data.createProfilePhotoUploadUrl;
}

/**
 * Mints a short-lived, write-only SAS URL for the authenticated member's own profile photo blob
 * (`createProfilePhotoUploadUrl` — self-scoped from the JWT, no arguments). No query key: this
 * isn't cacheable data, it's a one-shot credential consumed immediately by the PUT in
 * {@link useSaveProfilePhoto}, and re-fetching it as a mutation each time it's needed is the
 * point, not something to dedupe.
 */
export function useRequestProfilePhotoUploadUrl(): UseMutationResult<ProfilePhotoUploadUrl, Error, void> {
  return useMutation({
    mutationFn: requestProfilePhotoUploadUrl,
  });
}
